(function (window, document) {
  'use strict';

  if (window.BYPConsentGate) return;

  var loaderElement = document.currentScript;
  var previewThemeId = loaderElement && loaderElement.dataset.previewThemeId;
  var californiaRegion = 'USCA';
  var customerPrivacy = null;
  var previewConsentAccepted = false;
  var state = {
    region: '',
    status: 'blocked',
    consent: '',
    reason: 'initializing',
    source: 'shopify'
  };

  function cloneState() {
    return {
      region: state.region,
      status: state.status,
      consent: state.consent,
      reason: state.reason,
      source: state.source
    };
  }

  function normalizeRegion(value) {
    return String(value || '').replace(/[^a-z]/gi, '').toUpperCase();
  }

  function previewOverrides() {
    var shopifyTheme = window.Shopify && window.Shopify.theme;
    if (!shopifyTheme || shopifyTheme.role !== 'unpublished') return null;
    if (previewThemeId && String(shopifyTheme.id) !== String(previewThemeId)) return null;

    var params = new URLSearchParams(window.location.search);
    var region = normalizeRegion(params.get('byp_region'));
    var consent = String(params.get('byp_consent') || '').toLowerCase();
    if (previewConsentAccepted) consent = 'granted';
    if (!region && consent !== 'granted' && consent !== 'denied') return null;

    return {
      region: region,
      consent: consent
    };
  }

  function explicitMarketingConsent(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return '';
    var consent = api.currentVisitorConsent() || {};
    var value = String(consent.marketing || '').toLowerCase();
    if (value === 'yes' || value === 'true' || value === 'granted') return 'yes';
    if (value === 'no' || value === 'false' || value === 'denied') return 'no';
    return '';
  }

  function publish(nextState) {
    state = nextState;
    var root = document.documentElement;
    root.dataset.bypConsentRegion = state.region || 'unknown';
    root.dataset.bypConsentStatus = state.status;
    root.dataset.bypConsentValue = state.consent || 'unset';
    root.dataset.bypConsentReason = state.reason;
    root.dataset.bypConsentSource = state.source;

    document.dispatchEvent(new CustomEvent('byp:consent-state-changed', {
      detail: cloneState()
    }));
  }

  function evaluateConsent() {
    var overrides = previewOverrides();
    var region = overrides && overrides.region
      ? overrides.region
      : normalizeRegion(customerPrivacy && customerPrivacy.getRegion && customerPrivacy.getRegion());
    var consent = overrides && overrides.consent === 'granted'
      ? 'yes'
      : overrides && overrides.consent === 'denied'
        ? 'no'
        : explicitMarketingConsent(customerPrivacy);
    var source = overrides ? 'preview' : 'shopify';

    if (!region) {
      publish({ region: '', status: 'blocked', consent: consent, reason: 'region_unavailable', source: source });
      return;
    }

    if (region !== californiaRegion) {
      publish({ region: region, status: 'allowed', consent: consent, reason: 'outside_california', source: source });
      return;
    }

    if (consent === 'yes') {
      publish({ region: region, status: 'allowed', consent: consent, reason: 'california_consent_granted', source: source });
      return;
    }

    publish({
      region: region,
      status: 'blocked',
      consent: consent,
      reason: consent === 'no' ? 'california_consent_denied' : 'california_consent_required',
      source: source
    });
  }

  function handleVisitorConsent(event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.marketingAllowed === true) previewConsentAccepted = true;
    evaluateConsent();
  }

  function initialize() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      publish({ region: '', status: 'blocked', consent: '', reason: 'privacy_api_unavailable', source: 'shopify' });
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          publish({ region: '', status: 'blocked', consent: '', reason: 'privacy_api_unavailable', source: 'shopify' });
          return;
        }

        customerPrivacy = window.Shopify.customerPrivacy;
        evaluateConsent();
      }
    );
  }

  window.BYPConsentGate = {
    getState: cloneState,
    isAllowed: function () {
      return state.status === 'allowed';
    },
    refresh: evaluateConsent
  };

  document.addEventListener('visitorConsentCollected', handleVisitorConsent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}(window, document));
